import { render, staticRenderFns } from "./PasswordRecover.vue?vue&type=template&id=5259620d&scoped=true"
import script from "./PasswordRecover.vue?vue&type=script&lang=js"
export * from "./PasswordRecover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5259620d",
  null
  
)

export default component.exports